(function () {
  'use strict';

  var CFG = window.FREE_GIFT || {};
  var GIFT_PROPS = (CFG.giftProps || ['_free_gift', '_free_gift_2']).slice();
  var GIFT_HANDLES = (CFG.giftHandles || []).filter(Boolean);
  var RULES = (CFG.rules || []).filter(function (r) { return r.enabled && Number(r.variantId) > 0; }).map(function (r) {
    return { prop: r.prop, variantId: Number(r.variantId), minSubtotal: Number(r.minSubtotal) || 0, title: cleanTitle(r.title || 'gift') };
  });
  var nativeFetch = window.fetch.bind(window);
  var busy = false, queued = false, debounceTimer, legacyChecked = false;

  function cleanTitle(title) { return String(title).replace(/\s*\(Free Item\)\s*$/i, '').trim(); }
  function giftProp(item) {
    var p = item && item.properties || {};
    for (var i = 0; i < GIFT_PROPS.length; i++) if (p[GIFT_PROPS[i]]) return GIFT_PROPS[i];
    return '';
  }
  function paidSubtotal(cart) {
    return (cart.items || []).reduce(function (sum, item) { return sum + (giftProp(item) ? 0 : Number(item.final_line_price) || 0); }, 0);
  }
  function paidQuantity(cart) {
    return (cart.items || []).reduce(function (sum, item) { return sum + (giftProp(item) ? 0 : Number(item.quantity) || 0); }, 0);
  }
  function activeRule(prop) {
    for (var i = 0; i < RULES.length; i++) if (RULES[i].prop === prop) return RULES[i];
    return null;
  }

  function correctionFor(cart) {
    var items = cart.items || [], subtotal = paidSubtotal(cart), paidQty = paidQuantity(cart), i;
    for (i = 0; i < items.length; i++) {
      var prop = giftProp(items[i]), matched = prop && activeRule(prop);
      if (prop && (!matched || Number(items[i].variant_id) !== matched.variantId)) return { type: 'change', key: items[i].key, quantity: 0 };
    }
    if (!legacyChecked && RULES.length) {
      var legacyRule = activeRule('_free_gift');
      if (legacyRule) {
        for (i = 0; i < items.length; i++) {
          if (!giftProp(items[i]) && Number(items[i].variant_id) === legacyRule.variantId && Number(items[i].final_line_price) === 0) {
            return { type: 'change', key: items[i].key, quantity: 0, legacy: true };
          }
        }
      }
      legacyChecked = true;
    }
    for (i = 0; i < RULES.length; i++) {
      var rule = RULES[i];
      var lines = items.filter(function (item) { return giftProp(item) === rule.prop; });
      var qualifies = paidQty > 0 && subtotal >= rule.minSubtotal;
      if (!qualifies && lines.length) return { type: 'change', key: lines[0].key, quantity: 0 };
      if (qualifies && !lines.length) return { type: 'add', rule: rule };
      if (qualifies && lines.length > 1) return { type: 'change', key: lines[lines.length - 1].key, quantity: 0 };
      if (qualifies && Number(lines[0].quantity) !== 1) return { type: 'change', key: lines[0].key, quantity: 1 };
    }
    return null;
  }

  function sectionNames() {
    var names = [], wp = document.querySelector('.wp-cart-body'), wrapper = wp && wp.closest('[id^="shopify-section-"]');
    if (wrapper) names.push(wrapper.id.replace('shopify-section-', ''));
    if (document.querySelector('cart-drawer')) names.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) names.push('cart-icon-bubble');
    if (document.getElementById('main-cart-items')) names.push('main-cart-items');
    if (document.getElementById('main-cart-footer')) names.push('main-cart-footer');
    return names.filter(function (n, i) { return names.indexOf(n) === i; }).slice(0, 5);
  }
  function mutationBody(correction, sections) {
    var body;
    if (correction.type === 'add') {
      var props = {}; props[correction.rule.prop] = 'true';
      body = { items: [{ id: correction.rule.variantId, quantity: 1, properties: props }] };
    } else body = { id: correction.key, quantity: correction.quantity };
    if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
    return body;
  }
  function paintSections(sections) {
    Object.keys(sections || {}).forEach(function (name) {
      if (!sections[name]) return;
      var parsed = new DOMParser().parseFromString(sections[name], 'text/html');
      if (name === 'cart-drawer') {
        var td = document.querySelector('cart-drawer'), sd = parsed.querySelector('cart-drawer');
        if (td && sd) td.innerHTML = sd.innerHTML;
        return;
      }
      var current = document.getElementById('shopify-section-' + name) || document.getElementById(name);
      var source = parsed.getElementById('shopify-section-' + name) || parsed.getElementById(name);
      if (current) current.innerHTML = source ? source.innerHTML : sections[name];
    });
  }
  function writeCart(correction) {
    var sections = sectionNames();
    return nativeFetch(correction.type === 'add' ? '/cart/add.js' : '/cart/change.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(mutationBody(correction, sections))
    }).then(function (response) {
      if (response.status >= 400 && response.status < 500) { var e = new Error('Shopify rejected a gift correction (' + response.status + ')'); e.stop = true; throw e; }
      if (!response.ok) throw new Error('Gift correction failed (' + response.status + ')');
      return response.json();
    }).then(function (data) {
      if (data.sections) paintSections(data.sections);
      else if (data.item_count === 0) window.location.reload();
      return data;
    });
  }
  function readCart() {
    return nativeFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read cart (' + response.status + ')');
      return response.json();
    });
  }
  function removeMissingGiftRows(cart) {
    var keys = (cart.items || []).filter(giftProp).map(function (item) { return item.key; });
    document.querySelectorAll('[data-gift-line][data-key]').forEach(function (row) {
      if (keys.indexOf(row.getAttribute('data-key')) === -1) row.remove();
    });
  }
  function updateCounters(cart) {
    var count = Number(cart.item_count) || 0;
    var cartLink = document.querySelector('.wp-nav__icon--cart');
    if (cartLink) {
      var badge = cartLink.querySelector('.wp-nav__badge');
      if (count > 0 && !badge) {
        badge = document.createElement('span'); badge.className = 'wp-nav__badge'; badge.setAttribute('aria-hidden', 'true'); cartLink.appendChild(badge);
      }
      if (badge) { badge.textContent = count || ''; if (!count) badge.remove(); }
      cartLink.setAttribute('aria-label', count ? 'Cart (' + count + ' items)' : 'Cart');
    }
    document.querySelectorAll('.cart-count-bubble > span:first-child').forEach(function (el) { el.textContent = count || ''; });
  }
  function grantedGiftNames(cart) {
    return RULES.filter(function (rule) {
      return (cart.items || []).some(function (item) { return giftProp(item) === rule.prop && Number(item.variant_id) === rule.variantId; });
    }).map(function (rule) { return rule.title; });
  }
  function broadcast(cart, added) {
    var detail = { source: 'wp-free-gift', wpFreeGift: true, cart: cart, paidSubtotal: paidSubtotal(cart), paidQuantity: paidQuantity(cart),
      rules: RULES.map(function (r) { return { prop: r.prop, minSubtotal: r.minSubtotal, title: r.title }; }),
      giftsAdded: added.slice(), giftTitle: added[0] || '' };
    removeMissingGiftRows(cart);
    updateCounters(cart);
    document.dispatchEvent(new CustomEvent('wp:free-gift-settled', { detail: detail }));
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart, wpFreeGift: true, giftData: detail });
    }
  }
  function showToast(names) {
    var unique = names.filter(function (n, i) { return names.indexOf(n) === i; });
    var notification = { gifts: unique, title: unique[0] || '', handled: false };
    document.dispatchEvent(new CustomEvent('wp:free-gifts-added', { detail: notification }));
    if (notification.handled) return;
    var toast = document.getElementById('wp-fg-toast');
    if (!toast) {
      toast = document.createElement('div'); toast.id = 'wp-fg-toast'; toast.className = 'wp-fg-toast'; toast.setAttribute('role', 'status'); toast.setAttribute('aria-live', 'polite');
      toast.innerHTML = '<span class="wp-fg-toast__icon" aria-hidden="true">🎁</span><span data-gift-message></span>'; document.body.appendChild(toast);
    }
    toast.querySelector('[data-gift-message]').textContent = unique.length === 1
      ? (CFG.toast && RULES[0] && unique[0] === RULES[0].title ? CFG.toast : unique[0] + ' was added free.')
      : unique.join(' and ') + ' were added free.';
    toast.classList.remove('is-on'); requestAnimationFrame(function () { toast.classList.add('is-on'); });
    clearTimeout(showToast.timer); showToast.timer = setTimeout(function () { toast.classList.remove('is-on'); }, 3600);
  }
  function reconcile(silent) {
    if (busy) { queued = true; return Promise.resolve(); }
    busy = true; queued = false;
    var added = [], lastCart;
    function pass(index) {
      return readCart().then(function (cart) {
        lastCart = cart;
        var correction = correctionFor(cart);
        broadcast(cart, []);
        if (!correction || index >= 8) return cart;
        if (correction.type === 'add') added.push(correction.rule.title);
        return writeCart(correction).then(function () { return pass(index + 1); });
      });
    }
    return pass(0).then(function (cart) { if (added.length && !silent) showToast(grantedGiftNames(cart)); broadcast(cart, added); return cart; })
      .catch(function (e) { console.warn('[wp-free-gift]', e.message || e); if (!e.stop && lastCart) broadcast(lastCart, []); })
      .then(function () { busy = false; if (queued) { queued = false; return reconcile(false); } });
  }
  function schedule() {
    clearTimeout(debounceTimer); debounceTimer = setTimeout(function () { reconcile(false); }, 150);
    clearTimeout(schedule.one); clearTimeout(schedule.two);
    schedule.one = setTimeout(function () { reconcile(true); }, 1200);
    schedule.two = setTimeout(function () { reconcile(true); }, 3000);
  }

  function filterSuggestionData(value) {
    if (!value || typeof value !== 'object') return value;
    Object.keys(value).forEach(function (key) {
      if (Array.isArray(value[key])) value[key] = value[key].filter(function (item) { return !item || GIFT_HANDLES.indexOf(item.handle) === -1; }).map(filterSuggestionData);
      else filterSuggestionData(value[key]);
    });
    return value;
  }
  function hideGiftProducts(root) {
    if (!GIFT_HANDLES.length || !root.querySelectorAll) return;
    GIFT_HANDLES.forEach(function (handle) {
      var selector = 'a[href*="/products/' + handle + '"]';
      var links = Array.prototype.slice.call(root.querySelectorAll(selector));
      if (root.matches && root.matches(selector)) links.unshift(root);
      links.forEach(function (link) {
        var container = link.closest('li,.card-wrapper,.wp-product-card,.product-grid__item,.predictive-search__list-item');
        if (container) container.remove(); else link.remove();
      });
    });
  }
  function installFetchHook() {
    var current = window.fetch;
    if (current && current._wpGiftHook) return;
    function hooked(input) {
      var url = typeof input === 'string' ? input : input && input.url || '';
      var result = current.apply(this, arguments);
      if (/\/search\/suggest\.json(?:\?|$)/.test(url) && GIFT_HANDLES.length) {
        result = result.then(function (response) {
          if (!response.ok) return response;
          return response.clone().json().then(function (json) {
            return new Response(JSON.stringify(filterSuggestionData(json)), { status: response.status, statusText: response.statusText, headers: response.headers });
          }).catch(function () { return response; });
        });
      }
      if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)) result.then(function (r) { if (r && r.status >= 200 && r.status < 300) schedule(); }).catch(function () {});
      return result;
    }
    hooked._wpGiftHook = true; window.fetch = hooked;
  }
  [0, 500, 1500, 3000, 6000].forEach(function (delay) { setTimeout(installFetchHook, delay); });

  var xhrOpen = XMLHttpRequest.prototype.open, xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) { this._wpGiftCartUrl = String(url || ''); return xhrOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(this._wpGiftCartUrl || '')) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) schedule(); });
    return xhrSend.apply(this, arguments);
  };
  document.addEventListener('submit', function (e) { if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(e.target && e.target.action || '')) schedule(); }, true);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) { if (!e || !e.wpFreeGift) schedule(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(); });
  window.addEventListener('pageshow', schedule);
  function start() {
    hideGiftProducts(document);
    if (GIFT_HANDLES.length && window.MutationObserver) {
      new MutationObserver(function (records) {
        records.forEach(function (record) { record.addedNodes.forEach(function (node) { if (node.nodeType === 1) hideGiftProducts(node); }); });
      }).observe(document.body, { childList: true, subtree: true });
    }
    reconcile(true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();

  window.__WP_FREE_GIFT_TEST__ = { paidSubtotal: paidSubtotal, paidQuantity: paidQuantity, correctionFor: correctionFor, reconcile: reconcile, filterSuggestionData: filterSuggestionData };
})();
